import { createContext, useContext, useEffect, useState } from "react";
import { SlidersHorizontal } from "lucide-react";
import { API } from "./config";

const Ctx = createContext({ ads: { enabled: false }, appLinks: {} });

export const AdsProvider = ({ children }) => {
  const [config, setConfig] = useState({ ads: { enabled: false }, appLinks: {} });

  useEffect(() => {
    fetch(`${API}/web/config`)
      .then((r) => r.json())
      .then(setConfig)
      .catch(() => {});
  }, []);

  useEffect(() => {
    const client = config.ads?.adsenseClient;
    if (!client || document.getElementById("adsense-script")) return;
    const s = document.createElement("script");
    s.id = "adsense-script";
    s.async = true;
    s.crossOrigin = "anonymous";
    s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
    document.head.appendChild(s);
  }, [config.ads?.adsenseClient]);

  return <Ctx.Provider value={config}>{children}</Ctx.Provider>;
};

export const useAds = () => useContext(Ctx);

const pushAd = () => {
  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  } catch {}
};

export const AdBanner = ({ className = "" }) => {
  const { ads } = useAds();
  useEffect(() => {
    if (ads?.adsenseClient) pushAd();
  }, [ads?.adsenseClient]);
  if (!ads?.adsenseClient) return null;
  return (
    <div className={`flex justify-center py-4 ${className}`} data-testid="ad-banner">
      <ins
        className="adsbygoogle"
        style={{ display: "block", width: "100%", maxWidth: 728, height: 90 }}
        data-ad-client={ads.adsenseClient}
        data-ad-slot={ads.slots?.banner || undefined}
        data-ad-format="horizontal"
      />
    </div>
  );
};

export const InFeedAd = () => {
  const { ads } = useAds();
  useEffect(() => {
    if (ads?.adsenseClient) pushAd();
  }, [ads?.adsenseClient]);
  if (!ads?.adsenseClient) return null;
  return (
    <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02]" data-testid="ad-infeed">
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={ads.adsenseClient}
        data-ad-slot={ads.slots?.infeed || undefined}
        data-ad-format="fluid"
        data-ad-layout="in-article"
      />
    </div>
  );
};

export const PrivacyOptionsLink = ({ compact = false }) => {
  if (compact) {
    return (
      <button
        type="button"
        title="Privacy options"
        data-testid="privacy-options-link"
        onClick={() => window.googlefc?.showRevocationMessage?.()}
        className="rounded-xl p-2.5 text-slate-500 transition-colors hover:bg-white/5 hover:text-white"
      >
        <SlidersHorizontal size={17} />
      </button>
    );
  }
  return (
    <button
      type="button"
      data-testid="privacy-options-link"
      onClick={() => window.googlefc?.showRevocationMessage?.()}
      className="text-left text-xs text-slate-600 transition-colors hover:text-slate-300"
    >
      Privacy options
    </button>
  );
};
